import React from 'react';
import { bool, object } from 'prop-types';
import glamorous from 'glamorous';

import CSS from './styles.css';
import Card from 'Shared/Card';


const AnnotationListViews = ({ deleteHighlight, displayAnnotations }) => {
  if (displayAnnotations.length === 0) {
    return (
      <div id="annotationList" className={ CSS['container'] }>
        <div className={ CSS['empty-message-box'] } tabIndex="0">
          <span className={ CSS['empty-message'] }>Empty Notebook</span>
          <span className={ CSS['empty-message'] }>Add a highlight or note in your ebook and look for them here.</span>
        </div>
      </div>
    );
  }

  return (
    <div id="annotationList" className={ CSS['container'] } tabIndex="0">
      {
        displayAnnotations.map((highlight, i) => {
          return <Card key={i}
            highlight={ highlight }
            deleteHighlight={ deleteHighlight }
          />
        })
      }
    </div>
  );
};

AnnotationListViews.propTypes = {};


export default AnnotationListViews;

